import {
  // Row,
  // InputNumber,
  Col,
  Card,
  Input,
  Form,
  DatePicker,
  Select,
  // Flex,
} from "antd";
// import { useEffect } from "react";
import classes from "../Pages.module.css";
import dayjs from "dayjs";
import { TimePicker } from "antd";

const { Option } = Select;


 


const DataField = (props) => {
  console.log(props,"props in datafield")
  // // console.log(props, "datafeild");

  // useEffect(() => {
  //   if (props.param === "cust_code" && props.customers && !props.value) {
  //     if (props.customers.length > 0) {
  //       const firstCustomer = props.customers[0].distributor_code;
  //       props.handleChange(firstCustomer, props.param); // Auto-select the first customer
  //     }
  //   }

  //   if (props.param === "place_of_supply" && props.addres && !props.value) {
  //     if (props.addres.length > 0) {
  //       const firstAddress = props.addres[0].del_site_code;
  //       props.handleChange(firstAddress, props.param); // Auto-select the first delivery site
  //     }
  //   }
  // }, [
  //   props.param,
  //   props.customers,
  //   props.addres,
  //   props.value,
  //   props.handleChange,
  // ]);
  return (
    <Col lg={props.lg} md={props.md} className={classes["Col"]}>
      {props.editMode ? (
        <Form layout="vertical">
          <Form.Item
            colon={false}
            style={{ margin: "0", padding: "0" }}
            label={
              <div
                style={{
                  padding: "0rem 0.5rem",
                  fontSize: "0.6rem",
                  fontWeight: "bold",
                }}
                className={classes["Label"]}
              >
                {props.name}
                {props.required ? <span style={{ color: "red" }}> *</span> : ""}
              </div>
            }
          >
            {" "}
            {props.type === "Date" ? (
              <DatePicker
                value={props.value ? dayjs(props.value, "DD-MM-YYYY") : null}
                format="DD-MM-YYYY"
                // style={{
                //   padding: "13.3px 63px 14px 24px",
                //   borderRadius: "50px",
                //   background: "transparent",
                //   width: "100%",
                //   border: "none",
                //   outline: "none",
                //   fontSize: "16px",
                //   fontWeight: "600",
                //   lineHeight: "1.5",
                //   color: "#071e54",
                //   WebkitAppearance: "none",
                //   WebkitBoxShadow:
                //     "inset 3px 3px 6px #bfc3cf, inset -3px -3px 6px #fff",
                //   boxShadow:
                //     "inset 3px 3px 6px #bfc3cf, inset -3px -3px 6px #fff",
                //   height: "40px",
                // }}
                // bordered={false}
                style={{
                  textAlign: "left",
                  width: "100%",
                  backgroundColor: "white",
                  color: "#1777C4",
                  fontWeight: "bold",
                  boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                }}
                onChange={(date, dateString) =>
                  props.handleChange(date, dateString, props.param)
                }
              />
            ) : props.type === "Time" ? (
              <TimePicker
                value={
                  props.value === null ? null : dayjs(props.value, "HH:mm:ss")
                }
                // value={props.value ? dayjs(props.value, "HH:mm:ss") : null}
                format="HH:mm:ss"
                style={{
                  textAlign: "left",
                  width: "100%",
                  backgroundColor: "white",
                  color: "#1777C4",
                  fontWeight: "bold",
                  boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                }}
                onChange={(time, timeString) =>
                  props.handleChange(time, timeString, props.param)
                }
              />
            ) : props.type === "DateTime" ? (
              <DatePicker
                showTime
                value={props.value ? dayjs(props.value, "DD-MM-YYYY") : null}
                format="DD-MM-YYYY HH:mm:ss"
                style={{
                  textAlign: "left",
                  width: "100%",
                  backgroundColor: "white",
                  color: "#1777C4",
                  fontWeight: "bold",
                  boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                }}
                onChange={(date, dateString) =>
                  props.handleChange(date, dateString, props.param)
                }
              />
            ) : props.type === "Select" ? (
              <Select
              id={props.id}
              value={props.value === null ? null : props.value}
              onChange={(value) => props.handleChange(value, props.param)}
              dropdownStyle={{ textTransform: "capitalize" }}
              style={{
                width: "100%",
                textAlign: "left",
                backgroundColor: "white",
                textTransform: "capitalize",
                color: "#1777C4",
                fontWeight: "bold",
                height: "33px",
                boxShadow: "rgba(100, 100, 111, 0.1) 0px 0px 12px 0px",
              }}
              placeholder="Search to Select"
              optionFilterProp="children"
            >
              {/* Render options based on the value of props.param */}
              {props.param === "cust_code" && props.customers?.rows?.length > 0 ? (
                // Render customer options
                props.customers.rows.map((customer) => (
                  <Option
                    key={customer.distributor_code}
                    value={customer.distributor_code}
                    style={{ textTransform: "capitalize", color: "#1777C4" }}
                  >
                    {customer.get_distributor}
                  </Option>
                ))
              ) : props.param === "place_of_supply"  && props.addres?.rows?.length > 0 ? (
                // Render address options for place_of_supply
                props.addres.rows.map((address) => (
                  <Option
                    key={address.del_site_code}
                    value={address.del_site_code}
                    style={{ textTransform: "capitalize", color: "#1777C4" }}
                  >
                    {address.add_1}
                  </Option>
                ))
              ) : props.options?.rows?.length > 0 ? (
                // Render generic options for other cases
                props.options.rows.map((option) => (
                  <Option
                    key={option[props.options.fields[0]?.name]}
                    value={option[props.options.fields[0]?.name]}
                    style={{ textTransform: "capitalize", color: "#1777C4" }}
                  >
                    {option[props.options.fields[1]?.name]}
                  </Option>
                ))
              ) : (
                // Show a disabled option if no data is available
                <Option disabled>No Options Available</Option>
              )}
            </Select>
            ) : (
              <Input
                placeholder="Enter"
                id={props.id}
                value={props.value ? props.value : null}
                disabled={props.disabled}
                // bordered={false}
                onChange={(e) => props.handleChange(e, props.param, props.id)}
                // style={{
                //   padding: "13.3px 63px 14px 24px",
                //   borderRadius: "50px",
                //   background: "transparent",
                //   width: "100%",
                //   border: "none",
                //   outline: "none",
                //   fontSize: "16px",
                //   fontWeight: "600",
                //   lineHeight: "1.5",
                //   color: "#071e54",
                //   WebkitAppearance: "none",
                //   WebkitBoxShadow:
                //     "inset 3px 3px 6px #bfc3cf, inset -3px -3px 6px #fff",
                //   boxShadow:
                //     "inset 3px 3px 6px #bfc3cf, inset -3px -3px 6px #fff",
                //   height: "40px",
                // }}

                onKeyPress={(e) => {
                  if (
                    props.param === "left_qty" ||
                    props.param === "tot_short" ||
                    props.param === "short" ||
                    props.param === "act_amt" ||
                    props.param === "freight_net_amount" ||
                    props.param === "net_amount"
                  ) {
                    const regex = /^[0-9.]$/; // Allow only numbers and decimal points

                    // Prevent key press if it's not a number or a period
                    if (!regex.test(e.key)) {
                      e.preventDefault();
                    }
                  }
                }}
                style={{
                  width: "100%",
                  textAlign:
                    props.param === "left_qty" ||
                    props.param === "tot_short" ||
                    props.param === "short" ||
                    props.param === "act_amt" ||
                    props.param === "freight_net_amount" ||
                    props.param === "net_amount"
                      ? "right"
                      : "left", // Conditionally set text align
                  backgroundColor: "white",
                  textTransform: "capitalize",
                  boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  // ...props.style,
                }}
              />
            )}
          </Form.Item>
        </Form>
      ) : (
        <Card
          bodyStyle={{ padding: "0.5rem 1rem" }}
          bordered={false}
          className={classes["Card"]}
        >
          {props.type === "Select" ? (
            <p className={classes["Label"]}>
              {props.name}
              <span className={classes["Data"]}>
                {props.value
                  ? props.options.rows[
                      props.options.rows.findIndex(
                        (element) =>
                          element[props.options.fields[0].name] === props.value
                      )
                    ][props.options.fields[1].name]
                  : null}
              </span>
            </p>
          ) : (
            <p className={classes["Label"]}>
              {props.name}{" "}
              <span className={classes["Data"]}>
                {props.value ? props.value : null}
              </span>
            </p>
          )}
        </Card>
      )}
    </Col>
  );
};

export default DataField;
